import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Color } from "Styles/Theme";

const Card = ({
  id,
  applicant_name,
  applicant_thumbnail,
  corrector_name,
  corrector_thumbnail,
  apply_company,
  apply_job_position,
  submitted_date,
  is_corrected,
}) => {
  return (
    <Container>
      <div>
        <Text>
          <p>
            {apply_company.length <= 8
              ? apply_company
              : `${apply_company.substring(0, 8)}...`}
          </p>
          <p>
            {apply_job_position.length <= 8
              ? apply_job_position
              : `${apply_job_position.substring(0, 8)}...`}
          </p>
        </Text>
        <Profile>
          <div>
            <img src={applicant_thumbnail} alt="user-profile" />
            <img src={corrector_thumbnail} alt="user-profile" />
          </div>
        </Profile>
      </div>
      <MoreInfo>
        <p>{`${new Date(submitted_date).toLocaleDateString()} 등록`}</p>
        {/* <p>
          {`${Number("30000").toLocaleString()}`}
          <span> 원</span>
        </p> */}
      </MoreInfo>
      <StatusButton
        to={is_corrected ? `result/${id}` : `correctoreditorlist/${id}`}
        is_corrected={is_corrected}
      >
        {is_corrected ? "완료" : "진행중"}
      </StatusButton>
    </Container>
  );
};

export default Card;

const Container = styled.article`
  padding: 36px;
  border: solid 1px rgba(54, 56, 58, 0.13);
  box-shadow: 7.9px 7.6px 12px 0 rgba(81, 81, 81, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  & > div:first-child {
    display: flex;
    margin-bottom: 20px;
  }
`;

const Text = styled.div`
  p:first-child {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 6px;
  }
  p:last-child {
    font-size: 18px;
    color: ${Color.gray};
  }
`;

const Profile = styled.div`
  flex: 1;
  & > div {
    display: flex;
    justify-content: flex-end;
    img {
      display: block;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      object-fit: cover;
      object-position: center;
    }
    img:first-child {
      margin-right: 8px;
    }
  }
`;

const MoreInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  p:first-child {
    color: ${Color.gray};
  }
  p:last-child {
    font-size: 18px;
    letter-spacing: -0.8px;
    span {
      font-size: 16px;
    }
  }
`;

const StatusButton = styled(Link)`
  margin-top: auto;
  width: 100%;
  height: 50px;
  border-radius: 10px;
  background-color: ${({ is_corrected }) =>
    is_corrected ? Color.purple : Color.gray};
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 16px;
  transition: opacity 0.1s linear;
  &:hover {
    opacity: 0.9;
  }
`;
